import { Box, styled } from "@mui/material";

export const ChipContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    gap: 4,
    backgroundColor: theme.palette.core.grey._30,
    borderRadius: 12,
    height: 24,
    alignItems: "center",
    paddingLeft: 4,
    paddingRight: 8,
}));
